module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a0c3f3a11b20c6777738f170e4b00098.svg";